export default function AwardedMessage() {
  return (
    <div className="relative overflow-hidden rounded-lg my-4 bg-emerald-600">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url('/pending_award_bg.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.1,
        }}
      />

      <div className="relative flex items-center justify-center px-8 py-6 gap-4">
        <svg
          className="w-6 h-6 text-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" />
        </svg>

        <span className="text-white text-lg font-normal">
          Tender Submitted :
        </span>

        <span className="text-white text-2xl font-normal tracking-wide">
          PENDING AWARD
        </span>
      </div>
    </div>
  );
}
